module.exports = __webpack_public_path__ + "aq.no1.60916a80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/aq.no1.jpg
// module id = utG1
// module chunks = 0